import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional Mã tự sinh
  account: undefined, // required, minLength: 1 Tài khoản
  password: undefined, // optional Mật khẩu
  disabled: undefined, // optional Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
  roles: [], // required, array items: required Danh sách quyền của người dùng
  passwordNew: undefined,
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.options = [
  {
    value: "true",
    label: "Tài khoản bị khóa",
  },
  {
    value: "false",
    label: "Tài khoản hoạt động",
  },
];
model.optionsRoles = [
  {
    value: "ContentAdmin",
    label: "ContentAdmin",
  },
  {
    value: "CustomerCareUser",
    label: "CustomerCareUser",
  },
  {
    value: "SalesManager",
    label: "SalesManager",
  },
  {
    value: "InGiaPhaSales",
    label: "InGiaPhaSales",
  },
  {
    value: "InGiaPhaDesigner",
    label: "InGiaPhaDesigner",
  },
];
model.optionsRolesAll = [
  {
    value: "FamilyAdmin",
    label: "FamilyAdmin",
  },
  {
    value: "FamilyUser",
    label: "FamilyUser",
  },
  {
    value: "User",
    label: "User",
  },
  {
    value: "SystemAdmin",
    label: "SystemAdmin",
  },
  {
    value: "ContentAdmin",
    label: "ContentAdmin",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "account",
  defaultSort: ["account", "ascending"],
  filtersFamily: ["roles:in:FamilyAdmin,FamilyUser,FamilyModerator&disabled=false"],
  filtersSale: ["roles:in:SalesManager,InGiaPhaSales"],
  filtersContent: ["roles:in:ContentAdmin"],
  filtersCustomerCareUser: ["roles:in:CustomerCareUser"],
  filtersDesigner: ["roles:in:InGiaPhaDesigner"],

  recordSelected: [],

  dataSearch: {
    value: {
      account: "",
      disabled: "",
      roles: "",
    },
    valid: {
      account: []
    },
    operator: {
      account: ":regex_i:",
      disabled: "",
      roles: ":in:",
    },
  },
};

export default model;
